export default {"src":"/_next/static/media/ic_keyboard_arrow_right.1ae7f762.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};